<template>
  <z-expansion-config-item 
    titulo="Terminal de Impressão" 
    subtitulo="Selecione o número do terminal de impressão do sistema"
  >
  <v-select
      v-model="store.configuracoes.APP_TERMINAL_IMPRESSAO"
      dense
      filled
      hide-details
      style="width: 200px"
      :items="gerarTerminais()"
      @change="updateConfig"
    ></v-select>
  </z-expansion-config-item>
</template>

<script setup>
// import { ref, onMounted } from 'vue';
import { range } from '@/app/helpers/utils';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import sistemaApi from '@/app/services/sistema';

import { gerarTerminais } from '@/app/helpers/utils';

const store = useConfigStore();

// import useCookie from '@/app/core/CookieCore';

// const cookie = useCookie();
// const APP_TERMINAL_IMPRESSAO = ref(null);

// onMounted(()=>{
//   APP_TERMINAL_IMPRESSAO.value = store.configuracoes.APP_TERMINAL_IMPRESSAO;
// })

async function updateConfig() {
  // cookie.setCookie('APP_TERMINAL_IMPRESSAO', APP_TERMINAL_IMPRESSAO.value, Infinity);
  sistemaApi.updateTerminalConfig({ 
    key: 'APP_TERMINAL_IMPRESSAO', 
    value: store.configuracoes.APP_TERMINAL_IMPRESSAO, 
  });
  // console.log(cookie.getCookie('APP_TERMINAL_IMPRESSAO'));
}


</script>

<style lang="scss" scoped>

</style>
